<template>
    <research-graph-block
        graph-title="述评与综述知识图谱"
        table-title="述评与综述三元组表格"
        :chart-data="chartData"
        :page-size="10"
        :node-limit="50"
    />
</template>

<script>
import ResearchGraphBlock from './research_graph_block.vue';
import reviewCommentaryData from '../mock/reviewCommentary.json';

export default {
    name: 'ReviewCommentary',
    components: { ResearchGraphBlock },
    data() {
        return { chartData: reviewCommentaryData };
    },
};
</script>
